/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unusual_Absence_DetectionInputs */



/**
* | output |
* | --- |
* | "Unusual absence detection" |
*
* @param {Unusual_Absence_DetectionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const unusual_absence_detection = /** @type {((inputs?: Unusual_Absence_DetectionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unusual_Absence_DetectionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Unusual absence detection")
	return /** @type {LocalizedString} */ ("Détection d'absence inhabituelle")
});